import React from "react";
import PropTypes from "prop-types";
import { QRCodeCanvas } from "qrcode.react";
import { Box, Button } from "@mui/material";
import "./styles.css";
import {
  QR_VALUE_DEV,
  QR_VALUE_TEST,
  QR_VALUE_PROD,
} from "../utils/constants.ts";
import { ENVIRONMENTS, getValueByEnv } from "../utils/runtimeEnv";

const QR_VALUE = getValueByEnv({
  [ENVIRONMENTS.LOCAL]: QR_VALUE_DEV,
  [ENVIRONMENTS.DEV]: QR_VALUE_DEV,
  [ENVIRONMENTS.TEST]: QR_VALUE_TEST,
  [ENVIRONMENTS.PROD]: QR_VALUE_PROD,
});

const warningTextStyle = {
  color: "red",
  marginBottom: "10px",
  fontWeight: 600,
  margin: "20px",
};

const instructionTextStyle = { marginBottom: "20px", fontWeight: 400 };

const waitTextStyle = { marginBottom: "10px", marginTop: "20px", fontWeight: 400 };

const SerialNumberCheck = ({ onAccept }) => {

  return (
    <Box className="terms-box">
      <div className="containertnc">
        <div style={warningTextStyle}>
          The customer has not registered this GM Energy product yet. Please
          have the customer register the product to continue with commissioning.
        </div>
        <div style={instructionTextStyle}>
          To register a GM Energy product, the customer can scan this QR code,
          or visit{" "}
          <a
            href="https://gmenergy.gm.com/for-home/here-to-help"
            style={{ color: "blue" }}
          >
            Customer Resources
          </a>{" "}
          on the GM Energy website.
        </div>
        <QRCodeCanvas className="verification-qr-code" value={QR_VALUE} />
        <div style={waitTextStyle}>
          Please wait to refresh this page until you receive confirmation the
          customer has completed product registration.
        </div>
        <div>
          <Button
            variant="contained"
            color="primary"
            onClick={onAccept}
            sx={{ margin: 3, backgroundColor: '#000', '&:hover': { backgroundColor: '#0009FF' } }}
          >
            Refresh
          </Button>
        </div>
      </div>
    </Box>
  );
};

SerialNumberCheck.propTypes = {
  onAccept: PropTypes.func.isRequired,
};

export default SerialNumberCheck;
